import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { IconButton, InputAdornment, Dialog, Grid, Typography, Button, TextField } from '@mui/material';
import { notification } from 'antd';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { getToken } from '../utils/common';
import logger from '../utils/logger';

export default function Reset() {
  const history = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorText, setErrorText] = useState('');
  const [errorText2, setErrorText2] = useState('');
  const [password2, setPassword] = useState('');
  const [loadings, setloading] = useState(false);
  const [email, setEmail] = useState('');
  const [isDeleteOpen, setisDeleteOpen] = useState(false);
  const handleTogglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  const handleTogglePasswordVisibilities = () => {
    setShowPassword(!showPassword);
  };
  const handlePasswordChange = (event) => {
    const newPassword = event.target.value;
    setPassword(newPassword);

    // Validate against the regex pattern
    const regexPattern = /^(?=.*[A-Z])(?=.*\d).{7,}$/;
    if (!regexPattern.test(newPassword)) {
      setErrorText('Password must be at least 7 characters long and contain an uppercase letter, a number.');
    } else {
      setErrorText('');
    }
    if (newPassword !== confirmPassword) {
      setErrorText2('Password must be same with Confirm Password');
    } else {
      setErrorText2('');
    }
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(currentUrl);
    urlParams.get('token');
  }, []);

  function extractNameAndEmailFromURL(url) {
    const urlParams = new URLSearchParams(url);
    const emailFromURL = urlParams.get('token');
    const decodedEmail = atob(emailFromURL);
    return { email: decodedEmail };
  }

  useEffect(() => {
    const currentUrl = window.location.href;
    const { email: extractedEmail } = extractNameAndEmailFromURL(currentUrl);

    setEmail(extractedEmail);
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const token = searchParams.get('token');

  const handleConfirmPasswordChange = (event) => {
    const newConfirmPassword = event.target.value;
    setConfirmPassword(newConfirmPassword);

    if (newConfirmPassword !== password2) {
      setErrorText2('Passwords do not match.');
    } else {
      setErrorText2('');
    }
  };

  const handleSubmit = async (event) => {
    setloading(true);
    event.preventDefault();
    // Perform additional actions here, like submitting the password
    const formData = {
      Password: password2,
      token,
    };

    // Define the API endpoint URL
    const apiUrl = `${window.REACT_APP_API_PURE}user/password/reset`;

    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken}`,
    });

    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData),
    };

    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          notification.error({
            message: 'Error',
            description: t('Password can`t be changed'),
            placement: 'top',
            duration: 5,
          });
        } else {
          notification.success({
            message: 'Success',
            description: 'Password changed successfully',
            placement: 'top',
            duration: 5,
          });
          setTimeout(() => {
            history('/login');
          }, 2000);
        }
      })
      .then((response) => {})
      .catch((error) => {
        setloading(false);

        logger.error('Error:', error);
      });
  };

  const handleCloseDeleteModalder = () => {
    setisDeleteOpen(false);
  };

  function DialogDelete() {
    return (
      <Dialog open={isDeleteOpen} onClose={handleCloseDeleteModalder}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>Password has been change!</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModalder}>Confirm</Button>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <form onSubmit={handleSubmit}>
      <section className="z-0 w-full h-screen bg-center bg-local bg-cover bg-dunes">
        <div className="z-100 container mx-auto px-4 h-screen">
          <div className="flex  content-center items-center justify-center h-screen">
            <div className="w-full lg:w-9/12 px-4">
              <div
                className="relative flex flex-col items-center min-w-0 break-words w-full mb-6 shadow-2xl shadow-blue-500/50 rounded-lg bg-blueGray-200 border-0"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                }}
              >
                <Grid container direction={'row'} alignItems="stretch">
                  <Grid
                    xs={12}
                    item
                    md={6}
                    style={{
                      backgroundImage: 'url(/assets/Frame1.png)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      height: 'screen',
                    }}
                  >
                    {''}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{
                      height: '100vh',
                      paddingTop: '20vh',
                      backgroundSize: 'cover',
                      paddingRight: 60,
                      paddingLeft: 60,
                    }}
                    textAlign={'center'}
                  >
                    {DialogDelete()}
                    <Grid container direction={'row'} spacing={1}>
                      <Grid item xs={12}>
                        <Typography variant="h3">Reset Password</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Password
                        </Typography>
                        <TextField
                          placeholder="Password"
                          id="Password"
                          fullWidth
                          size="small"
                          type={showPassword2 ? 'text' : 'password'}
                          value={password2}
                          onChange={handlePasswordChange}
                          error={Boolean(errorText)}
                          helperText={errorText}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleTogglePasswordVisibility2}>
                                  {showPassword2 ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography align="start" variant="body2">
                          Confirm Password
                        </Typography>
                        <TextField
                          placeholder="Confirm Password"
                          id="Confirm-Password"
                          size="small"
                          fullWidth
                          type={showPassword ? 'text' : 'password'}
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                          error={Boolean(errorText2)}
                          helperText={errorText2}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleTogglePasswordVisibilities}>
                                  {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      {}

                      <Grid item xs={12} textAlign={'-webkit-center'}>
                        <Button
                          fullWidth
                          className="bg-blue-400 shadow-lg shadow-blue-500/50 text-white"
                          disabled={
                            loadings ||
                            password2 === '' ||
                            confirmPassword !== password2 ||
                            !/^(?=.*[A-Z])(?=.*\d).{7,}$/.test(password2)
                          }
                          type="submit"
                          variant="contained"
                          color="primary"
                        >
                          Submit
                        </Button>
                        <hr style={{ aligtenContent: 'center' }} className="mt-6 border-b-1 border-blueGray-300" />
                      </Grid>
                      {}
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  );
}
